import { useQuery } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'
import type { UsuarioActual } from '../api/modelos'

/** `soporte` (plataforma) pasa donde pasa `admin` (spec 000). */
export function esAdmin(usuario: Pick<UsuarioActual, 'roles'> | null | undefined): boolean {
  return (usuario?.roles ?? []).some((rol) => rol === 'admin' || rol === 'soporte')
}

/** Identidad del token con sus roles: decide el menú y las acciones de admin. */
export function useUsuarioActual() {
  const api = useApi()
  return useQuery<UsuarioActual, ErrorApi>({
    queryKey: ['sesion', 'yo'],
    queryFn: ({ signal }) => api.pedir<UsuarioActual>('/api/sesion/yo', { senal: signal }),
    staleTime: 5 * 60_000,
  })
}

/** Atajo: ¿el usuario actual es administrador? Mientras carga, no. */
export function useEsAdmin(): boolean {
  return esAdmin(useUsuarioActual().data)
}
